import './App.css';
import * as React from 'react';
import Container from '@mui/material/Container';
import styled from "@emotion/styled";
import { Grid } from '@mui/material';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import * as PropTypes from 'prop-types';
import Home from './components/home';
import Tokenomics from './components/tokenomics'

const Wrapper = styled.div`
background-image: url('./assets/background image.png');
background-size: cover;
padding-top:20px;
.css-1aquho2-MuiTabs-indicator {
  height: 0px !important;
  display: none !important;
  background-color:#1976d200 !important;
}
`;
const ElementWrapper = styled(Container)`
height: 100vh;
padding-top:40px;
height: calc(100vh - 90px);
@media (max-width: 749px){
  height: auto;
}
`
;
const GridWrapper = styled(Grid)`
@media (max-width: 600px){
flex-direction: column-reverse;
}
`

const Copyrights = styled.p`
font-family:Poppins;
font-size:20px;
color:#fff;
text-align:center;
font-weight:400;
@media (max-width: 749px){
  font-size: 14px;
  margin-top: 40px;
}
`;


const CustomTabs = styled(Tab)`
color:#fff;
text-decoration: underline;
font-family:Poppins;
font-size:20px;
font-weight:bold;
&:hover {
  color: #F7931A;
}
&.Mui-selected {
  color: #F7931A !important;
  text-decoration: underline;
}
@media (max-width: 600px){
  margin:auto;
}
`
function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box>
          <div>{children}</div>
        </Box>
      )}
    </div>
  );
}
TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}
function App() {
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  return (


    <Wrapper>
      <ElementWrapper>
          <GridWrapper container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
              <Grid item xs={12} sm={5} md={5} sx={{paddingTop:'20px!important' , justifyContent:'center' , display: 'grid' , justifyItems: 'center' }}>
                <img style={{maxWidth: "85%"}} src="./assets/Group 7559.png" alt='iBtc'/>
              </Grid>
              <Grid item xs={12} sm={7} md={7}>
              <Box sx={{ width: '100%' }}>
                  <Box sx={{ borderBottom: 1, borderColor: 'divider' }} aria-label="basic tabs example">
                    <Tabs value={value} onChange={handleChange} aria-label="basic tabs example">
                      <CustomTabs label="Home" {...a11yProps(0)} />
                      <CustomTabs label="Tokenomics" {...a11yProps(1)} />
                    </Tabs>
                  </Box>
                  <TabPanel value={value} index={0}>
                    <Home />
                  </TabPanel>
                  <TabPanel value={value} index={1}>
                    <Tokenomics />
                  </TabPanel>
                </Box>
              </Grid>
        </GridWrapper>
      </ElementWrapper>
      <Container>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Copyrights>© 2023 iBitcoin. All rights reserved</Copyrights>
          </Grid>
        </Grid>
      </Container>
    </Wrapper>
  );
}

export default App;
